module.exports = __webpack_public_path__ + "static/media/DELETEselectArrowDown.7ddbaec0.svg";